import VueRenderPlugin from 'rete-vue-render-plugin';

// Mirrors rete-vue-render-plugin's own `kebab` filter (src/filters.js) without
// depending on Vue's global filter registration.
const kebab = (str) => str.toLowerCase().replace(/ /g, '-');

// Plain-object Vue component (no .vue SFC) reproducing rete-vue-render-plugin's
// default Node.vue structure, but with unscoped class names so gh_automation.scss
// can style it directly instead of fighting the library's scoped `[data-v-*]` CSS.
export default {
  mixins: [VueRenderPlugin.mixin],
  components: {
    Socket: VueRenderPlugin.Socket
  },
  render(h) {
    const nodeClass = ['node', this.selected(), kebab(this.node.name)].filter(Boolean);

    return h('div', { class: nodeClass }, [
      h('div', { staticClass: 'title' }, this.node.name),

      ...this.outputs().map((output) => h('div', { key: output.key, staticClass: 'output' }, [
        h('div', { staticClass: 'output-title' }, output.name),
        h('Socket', {
          props: { type: 'output', socket: output.socket },
          directives: [{ name: 'socket', arg: 'output', value: output }]
        })
      ])),

      ...this.controls().map((control) => h('div', {
        key: control.key,
        staticClass: 'control',
        directives: [{ name: 'control', value: control }]
      })),

      ...this.inputs().map((input) => h('div', { key: input.key, staticClass: 'input' }, [
        h('Socket', {
          props: { type: 'input', socket: input.socket },
          directives: [{ name: 'socket', arg: 'input', value: input }]
        }),
        h('div', {
          staticClass: 'input-title',
          directives: [{ name: 'show', value: !input.showControl() }]
        }, input.name),
        h('div', {
          staticClass: 'input-control',
          directives: [
            { name: 'show', value: input.showControl() },
            { name: 'control', value: input.control }
          ]
        })
      ]))
    ]);
  }
};
